/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAtom } from "jotai";
import React from "react";
import Slider from "react-slick";
import {
    activeProvidersAtom,
    categoryTypeAtom,
    providersAtom,
    showProvidersAtom,
} from "../state/games";
import ArrowNextIcon from "@icons/arrow-next.svg";
import ArrowPrevIcon from "@icons/arrow-prev.svg";
import Icon from "./Icon";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";

function SliderNextArrow(props: any) {
    const { onClick } = props;
    return (
        <div className="arrow-next" onClick={onClick}>
            <Icon icon={ArrowNextIcon} />
        </div>
    );
}

function SliderPrevArrow(props: any) {
    const { onClick } = props;
    return (
        <div className="arrow-prev" onClick={onClick}>
            <Icon icon={ArrowPrevIcon} />
        </div>
    );
}

const ProvidersSlider = () => {
    const [providers] = useAtom(providersAtom);
    const [activeProviders, setActiveProviders] = useAtom(activeProvidersAtom);
    const [, setShowProviders] = useAtom(showProvidersAtom);
    const navigate = useNavigate();
    const [categoryType] = useAtom(categoryTypeAtom);

    const settings = {
        dots: false,
        speed: 500,
        slidesToShow: categoryType === 2 ? 8 : 8,
        slidesToScroll: categoryType === 2 ? 8 : 8,
        useCSS: true,
        infinite: false,
        nextArrow: <SliderNextArrow />,
        prevArrow: <SliderPrevArrow />,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: categoryType === 2 ? 5 : 5,
                    slidesToScroll: categoryType === 2 ? 5 : 5,
                    infinite: true,
                },
            },
        ],
    };
    return (
        <>
            <div className="providers-slider">
                <Slider {...settings}>
                    {providers?.map(provider => {
                        return (
                            <div
                                className={
                                    activeProviders.includes(provider.id)
                                        ? "provider-slider-item active"
                                        : "provider-slider-item"
                                }
                                onClick={() => {
                                    setActiveProviders([provider.id]);
                                    setShowProviders(false);
                                    navigate(routes.pages.games);
                                }}
                                key={provider.id}
                            >
                                <i className={`icon icon-${provider.slug}`}></i>
                                <span className="provider-title">{provider.name}</span>
                                <svg className="provider_svg">
                                    <use xlinkHref={`#${provider.slug}`}></use>
                                </svg>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </>
    );
};
export default ProvidersSlider;
